import { render, staticRenderFns } from "./InformeRevisionCaptura.vue?vue&type=template&id=38931ec0&"
import script from "./InformeRevisionCaptura.vue?vue&type=script&lang=js&"
export * from "./InformeRevisionCaptura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports